import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LiberarCitaComponent } from './liberar-cita/liberar-cita.component';
import { ConsultaReversionesOpComponent } from './consulta-reversiones-op/consulta-reversiones-op.component';
import { ConsultaHistorialCitaComponent } from './consulta-historial-cita/consulta-historial-cita.component';
import { ConsultaHistorialComprometidaComponent } from './consulta-historial-comprometida/consulta-historial-comprometida.component';
import { CrearPoligonoComponent } from './crear-poligono/crear-poligono.component';
import { DashboardPoligonoComponent } from './dashboard-poligono/dashboard-poligono.component';
import { HistorialAperturaCierreComponent } from './historial-apertura-cierre/historial-apertura-cierre.component';
import { EtiquetasTrazabilidadComponent } from './etiquetas-trazabilidad/etiquetas-trazabilidad.component';
import { GestionarOpsClientesComponent } from './gestionar-ops-clientes/gestionar-ops-clientes.component';
import { OpsSinPoligonoComponent } from './ops-sin-poligono/ops-sin-poligono.component';

const routes: Routes = [
  {
    path: 'liberar-cita',
    component: LiberarCitaComponent,
  },
  {
    path: 'consulta-reversiones-op',
    component: ConsultaReversionesOpComponent,
  },
  {
    path: 'consulta-historial-cita',
    component: ConsultaHistorialCitaComponent,
  },
  {
    path: 'consulta-historial-comprometida',
    component: ConsultaHistorialComprometidaComponent,
  },
  {
    path: 'crear-poligono',
    component: CrearPoligonoComponent,
  },
  {
    path: 'dashboard-poligono',
    component: DashboardPoligonoComponent,
  },
  {
    path: 'historial-apertura-cierre',
    component: HistorialAperturaCierreComponent,
  },
  {
    path: 'etiquetas-trazabilidad',
    component: EtiquetasTrazabilidadComponent,
  },
  {
    path: 'gestionar-ops-clientes',
    component: GestionarOpsClientesComponent,
  },
  {
    path: 'ops-sin-poligono',
    component: OpsSinPoligonoComponent,
  },
  { path: '', redirectTo: 'logistica', pathMatch: 'prefix' },
  { path: '**', redirectTo: 'logistica', pathMatch: 'prefix' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LogisticaRoutingModule { }